import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccf515d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner large" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]

import { fetchData } from "@/api"
import { useUserStore } from "@/store"
import { ref, onMounted } from "vue"
import WebhookModal from "../modals/WebhookModal.vue"
import { notify } from "@/globals/notification"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useUserStore()
const modal_webhook = ref([])
const webhook_index = ref(null)
const loading = ref(false)
const show = ref(false)

const openWebhookSettings = (data: number) => {
  show.value = true
  modal_webhook.value = store.webhooks[data]
  webhook_index.value = data
}

const closeModal = () => {
  show.value = false
}

const getTeams = async () => {
  loading.value = true
  const data = await fetchData(`${process.env.VUE_APP_API_URL}/figma/webhooks`)

  if ("error" in data) {
    if (data.error != null) {
      loading.value = false
      if (!data?.silence) {
        notify(data.error, true)
        return
      }
    }
  }

  if (store.webhooks.length != 0) {
    store.webhooks = []
    store.total_tasks_created = 0
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  data.webhooks.forEach((webhook: any) => {
    store.webhooks.push(webhook)
    store.total_tasks_created += webhook.total_tasks
  })

  loading.value = false
}

const getAsanaWorkspaces = async () => {
  if (JSON.parse(localStorage.getItem("has_asana")) === false) {
    return
  }

  if (localStorage.getItem("asana_workspaces")) {
    store.asana_workspaces = JSON.parse(
      localStorage.getItem("asana_workspaces")
    )
    return
  }

  const data = await fetchData(
    `${process.env.VUE_APP_API_URL}/asana/workspaces`
  )

  // eslint-disable-next-line no-prototype-builtins
  if (data.hasOwnProperty("error")) {
    return
  }
  store.asana_workspaces = data.workspaces
  localStorage.setItem("asana_workspaces", JSON.stringify(data.workspaces))
}

onMounted(() => {
  getTeams()
  getAsanaWorkspaces()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (show.value)
      ? (_openBlock(), _createBlock(WebhookModal, {
          key: 0,
          webhook: modal_webhook.value,
          webhook_index: webhook_index.value,
          onCloseModal: closeModal
        }, null, 8, ["webhook", "webhook_index"]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).webhooks, (webhook, index) => {
      return (_openBlock(), _createElementBlock("ul", {
        id: "team-list",
        key: webhook.id
      }, [
        _createElementVNode("li", {
          onClick: ($event: any) => (openWebhookSettings(index))
        }, [
          _createElementVNode("h3", null, _toDisplayString(webhook.team.team_name), 1),
          _createElementVNode("p", null, _toDisplayString(webhook.total_comments ? webhook.total_comments : 0) + " comments captured –– " + _toDisplayString(webhook.total_tasks ? webhook.total_tasks : 0) + " tasks created in " + _toDisplayString(webhook.asana_workspace_name) + " / " + _toDisplayString(webhook.asana_project_name), 1)
        ], 8, _hoisted_4)
      ]))
    }), 128))
  ], 64))
}
}

})